import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function RefundPolicy() {
  const navigate = useNavigate();
  const { id } = useParams();
  function handleTransactionId() {
    navigate(id === undefined ? '/refund' : `/refund/${id}`);
    window.scrollTo(0, 0);
  }

  return (
    <div id="content" className="min-h-[100vh] w-full">
      <div className="w-full flex flex-col justify-center items-center">
        {/* Refund Policy banner */}
        <div className="w-full bg-bgAlternate px-[10px] lg:px-[40px] py-[20px] lg:py-[30px] overflow-x-hidden">
          <div className="w-full flex flex-row items-center mb-0">
            <h1 className="text-white font-anton font-normal uppercase text-[30px] md:text-[40px] lg:text-[48px] leading-tight ml-[10px] lg:ml-[20px]">
              REFUND POLICY
            </h1>
          </div>
        </div>
      </div>

      {/* Content Sections Container */}
      <div
        className="w-full lg:pt-0 lg:pb-8"
        style={{
          background: "linear-gradient(to right, #1B062F 0%, #4e2581 100%)",
        }}
      >
        <div className="w-full px-[10px] lg:px-[40px] pt-0 pb-[20px] lg:pt-0 lg:pb-[30px]">
          <div className="bg-header p-[20px] lg:p-[30px]">
            <div className="font-chakra text-white text-[14px] md:text-[16px] leading-relaxed space-y-4">
              <p className="text-white font-bold">PUKKA CRICKET8 ENTERTAINMENT INDIA PRIVATE LIMITED</p>
              <p className="text-white font-bold">(Platform Cricket8)</p>
              <p className="text-white font-bold">REFUND POLICY</p>
              <p className="text-white">
                This Policy is a legally binding document between you ("Visitor"/
                "User") and Pukka Cricket8 Entertainment India Private Limited & its platform Cricket8
                ("Company", "Platform", "we", "us", and "our").
              </p>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  ABOUT CRICKET8
                </h2>
                <p className="text-white">
                  Cricket8 is a community built by cricket fans, for cricket fans. With
                  a growing base of 800,000 passionate cricket enthusiasts, we are more
                  than just a sports platform. Our mission is to bring fans closer to
                  the game they love through high-quality gaming, real-time engagement,
                  and interactive experiences.
                </p>
              </div>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  OUR PRODUCTS
                </h2>
                <p className="text-white">
                  Cricket8 offers a premium, real-time experience for cricket lovers,
                  including:
                </p>
                <ul className="text-white">
                  <li>
                    Live Gaming: Ball by ball, over by over, and match by match,
                    covering every market.
                  </li>
                  <li>
                    Live Sports Data: Instant updates, scores, and in-depth statistics.
                  </li>
                  <li>
                    Live Streaming Commentary: Bringing the action to life, ball by
                    ball.
                  </li>
                  <li>
                    Exclusive Videos & Podcasts: Expert insights, match analysis, and
                    behind-the-scenes content.
                  </li>
                </ul>
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  PLAY. COMPETE. WIN (BRAGGING RIGHTS).
                </h2>
                <p className="text-white">
                  Our games capture the thrill of picking outcomes using virtual coins only —
                  free social games for entertainment:
                </p>
                <ul className="text-white">
                  <li>
                    Play for fun: Compete, strategize, and challenge your friends using virtual
                    coins only.
                  </li>
                  <li>
                    Virtual Coins, Real Excitement: Players can get Rubies, convert them
                    into virtual coins, and climb leaderboards for ultimate bragging
                    rights.
                  </li>
                </ul>
              </div>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  CANCELLATION AND REFUND POLICY FOR Cricket8.com
                </h2>
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  1. PAYMENT AND BILLING
                </h2>
                <p className="text-white">
                  1.1 PAYMENT OVERVIEW
                </p>
                <p className="text-white">
                  Our platform offers services that can be purchased using Stripe. By
                  completing a payment, you confirm that you are authorized to use the
                  selected payment method and that all payment details provided are
                  accurate.
                </p>
                <p className="text-white">
                  1.2 TRANSACTION PROCESSING
                </p>
                <p className="text-white">
                  Payments made through Stripe are processed in accordance with their
                  terms of service. Please refer to these terms for more details about
                  the transaction process and any associated requirements.
                </p>
                <p className="text-white">1.3 PRICING</p>
                <p className="text-white">
                  All prices displayed on our platform are inclusive of applicable taxes
                  unless stated otherwise. Prices are subject to change at any time
                  without prior notice.
                </p>
              </div>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  2. REFUNDS
                </h2>
                <p className="text-white">
                  2.1 ELIGIBILITY FOR REFUNDS
                </p>
                <p className="text-white">
                  Refund requests must comply with this policy and Stripe's refund
                  policies. Refunds will only be issued to the original payment method
                  used at the time of purchase. Refunds for ruby pack purchases only
                  apply to packs that have not yet been spent in full or in part (spent
                  on play coins). We cannot offer part refunds for unspent rubies. No
                  cash refunds will be issued under any circumstances, as our platform
                  does not involve monetary or tangible rewards.
                </p>
                <p className="text-white">
                  2.2 HOW TO REQUEST A REFUND
                </p>
                <p className="text-white">
                  To request a refund, please send us the following information via our
                  customer contact form:
                </p>
                <ul className="text-white">
                  <li>Order ID</li>
                  <li>Payment reference number (Stripe Payment / Transaction ID)</li>
                  <li>Reason for refund</li>
                  <li>Supporting documents (if applicable)</li>
                  <li>
                    Our team will review your request and respond within 3–5 business
                    days.
                  </li>
                </ul>
                <p className="text-white">
                  2.3 REFUND TIMELINES
                </p>
                <p className="text-white">
                  If your refund is approved, Stripe will initiate the refund to the
                  original payment method. Refunds are usually credited within 5–10
                  business days, depending on your bank or card issuer. You will be
                  notified when the refund is processed.
                </p>
                <p className="text-white">
                  2.4 NON-REFUNDABLE ITEMS
                </p>
                <p className="text-white">
                  Refunds will not be issued for the following:
                </p>
                <ul className="text-white">
                  <li>
                    Digital goods or services that have been accessed, used, or
                    downloaded.
                  </li>
                  <li>
                    Items marked as "final sale" or otherwise non-refundable at the time
                    of purchase.
                  </li>
                  <li>
                    Issues caused by user error or misuse of the product or service.
                  </li>
                  <li>
                    Virtual coins (converted from rubies) that have been used in any
                    capacity within our games.
                  </li>
                </ul>
              </div>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  3. VIRTUAL CURRENCY ONLY — NO CASH REWARDS
                </h2>
                <p className="text-white">
                  3.1 NATURE OF OUR GAMES
                </p>
                <p className="text-white">
                  All games on Cricket8 are casual, social, and skill-based, designed for
                  entertainment and competition among fans.{' '}
                  <span className="font-bold">
                    They are intended purely for entertainment and do not offer cash
                    prizes, monetary rewards, or tangible items as incentives.
                  </span>{' '}
                  Cricket8 complies with applicable Indian online gaming regulations. See
                  our{' '}
                  <Link className="underline font-bold text-white" to="/compliance">
                    Compliance page
                  </Link>{' '}
                  for details.
                </p>
                <p className="text-white">
                  3.2 VIRTUAL CURRENCY POLICY
                </p>
                <p className="text-white">
                  Virtual coins obtained through the purchase of rubies are purely for
                  in-game use and cannot be redeemed for cash, monetary rewards, or
                  tangible goods. These virtual coins are non-transferable,
                  non-redeemable, and cannot be exchanged for any form of real-world
                  value. They can only be used within the Cricket8 platform for in-game
                  activities such as accessing premium features, unlocking additional
                  content, or enhancing gameplay.
                </p>
                <p className="text-white">
                  3.3 NO CASH OR MONETARY REWARDS
                </p>
                <p className="text-white">
                  No cash prizes or rewards of monetary or tangible value are provided
                  to players, regardless of game outcomes or performance. Players earn
                  only virtual coins, which have no cash value and cannot be withdrawn
                  or converted into real money.
                </p>
              </div>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  4. UNAUTHORIZED TRANSACTIONS
                </h2>
                <p className="text-white">
                  If you believe a transaction was unauthorized, immediately report it
                  to Stripe via their customer support team. We will work with
                  Stripe to resolve the issue.
                </p>
              </div>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  5. CHANGES TO THIS POLICY
                </h2>
                <p className="text-white">
                  We may update this Refund Policy from time to time. Updates will be
                  posted on our website, and significant changes will be communicated to
                  you via email or other means. Continued use of our website after
                  updates constitutes acceptance of the revised policy.
                </p>
              </div>
              <div className="mb-6">
                <h2 className="text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase">
                  6. CONTACT INFORMATION
                </h2>
                <p className="text-white">
                  If you have any questions, concerns, or refund requests, please
                  contact us through our customer{' '}
                  <Link className="underline font-bold text-white" to="/contact">
                    support form
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
